/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Categories_NoticeInputs */

const en_visa_categories_notice = /** @type {(inputs: Visa_Categories_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General information only—not legal advice or an eligibility determination. Immigration advice, category selection, and filings must be handled by an independent U.S.-licensed attorney or DOJ-accredited representative.`)
};

const pt_visa_categories_notice = /** @type {(inputs: Visa_Categories_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas informações gerais — não constituem aconselhamento jurídico nem determinação de elegibilidade. A orientação migratória, a escolha de categoria e as apresentações devem ser conduzidas, de forma independente, por um advogado de imigração habilitado nos EUA ou um representante credenciado pelo DOJ.`)
};

const es_visa_categories_notice = /** @type {(inputs: Visa_Categories_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información general solamente: no constituye asesoramiento legal ni una determinación de elegibilidad. La orientación migratoria, la selección de categoría y las presentaciones deben ser realizadas de forma independiente por un abogado de inmigración habilitado en EE. UU. o un representante acreditado por el DOJ.`)
};

/**
* | output |
* | --- |
* | "General information only—not legal advice or an eligibility determination. Immigration advice, category selection, and filings must be handled by an independ..." |
*
* @param {Visa_Categories_NoticeInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_categories_notice = /** @type {((inputs?: Visa_Categories_NoticeInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Categories_NoticeInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_categories_notice(inputs)
	if (locale === "es") return es_visa_categories_notice(inputs)
	return en_visa_categories_notice(inputs)
});